export const getMessages = async (language: string): Promise<Record<string, string>> => {
  try {
    const response = await fetch(`/intl/${language}.json`)
    if (!response.ok) {
      throw new Error()
    }
    return await response.json()
  } catch {
    throw new Error('Unable to load messages')
  }
}
